import { useRef as n, useEffect as t } from "react";
export default function (e, r, i) {
  void 0 === i && (i = global);
  var o = n();
  t(function () {
    o.current = r;
  }, [r]), t(function () {
    if (i && i.addEventListener) {
      var n = function n(_n) {
        return o.current(_n);
      };

      return i.addEventListener(e, n), function () {
        i.removeEventListener(e, n);
      };
    }
  }, [e, i]);
}